// Extracted from layout/theme.liquid so it is cached across pageviews.
(function initYcFormsMobileTeaser() {
        // Keep the inline B2B application outside the mobile signup-popup controller.
        // Viewport and form mutations must never hide the application while typing.
        if (/\/pages\/wholesale-application\/?$/i.test(window.location.pathname)) return;

        const isDesignMode = document.documentElement.classList.contains('shopify-design-mode');

        if (isDesignMode) return;

        const dismissKey = 'yc-shopify-forms-mobile-dismissed';
        const hostSelector = 'shopify-forms-embed#app-embed, shopify-forms-embed';
        const nestedSelector = 'form-embed';
        const shadowStyleId = 'yc-forms-mobile-shadow-style';
        const popupSelectors = [
          'dialog[open]',
          '[role="dialog"]',
          '[aria-modal="true"]',
          '[data-testid*="modal"]',
          '[data-testid*="popup"]',
        ];
        const triggerSelectors = [
          '[data-testid*="teaser"] button',
          '[data-testid*="open"]',
          'button[aria-haspopup="dialog"]',
          'button[aria-controls]',
          'button',
          '[role="button"]',
        ];
        const denylist = ['close', 'dismiss', 'cancel', 'no thanks', '×'];
        const sessionStore = (() => {
          try {
            return window.sessionStorage;
          } catch (error) {
            return null;
          }
        })();
        const copy = getLocalizedCopy();
        let isDismissed = sessionStore?.getItem(dismissKey) === '1';
        let embedHost = null;
        let teaserNode = null;
        let popupWasVisible = false;

        document.body.classList.add('yc-forms-mobile-managed');

        function getLocalizedCopy() {
          const locale = (document.documentElement.lang || 'en').toLowerCase();
          if (locale.startsWith('ja')) {
            return {
              eyebrow: 'Seeds 会員特典',
              title: '8% OFF',
              meta: '登録で100シード・初回注文で300シード',
              closeLabel: 'フォーム案内を閉じる',
              openLabel: '8% OFF フォームを開く',
            };
          }
          if (locale.startsWith('fr')) {
            return {
              eyebrow: 'Cadeau Seeds',
              title: '8% OFF',
              meta: '+100 Seeds + 300 1re commande',
              closeLabel: 'Fermer l’annonce du formulaire',
              openLabel: 'Ouvrir le formulaire 8% OFF',
            };
          }
          if (locale.startsWith('de')) {
            return {
              eyebrow: 'Seeds Bonus',
              title: '8% OFF',
              meta: '+100 Seeds + 300 erste Bestellung',
              closeLabel: 'Formular-Hinweis schliessen',
              openLabel: '8% OFF Formular öffnen',
            };
          }
          return {
            eyebrow: 'Seed Rewards',
            title: '8% OFF',
            meta: '+100 Seeds + 300 first order',
            closeLabel: 'Close signup teaser',
            openLabel: 'Open 8% off signup form',
          };
        }

        function injectShadowStyles(root) {
          if (!root || root.getElementById?.(shadowStyleId)) return;
          const style = document.createElement('style');
          style.id = shadowStyleId;
          style.textContent = `
            :host([data-yc-mobile-managed]:not([data-yc-mobile-open])) {
              visibility: hidden !important;
              opacity: 0 !important;
              pointer-events: none !important;
            }

            :host([data-yc-mobile-managed]:not([data-yc-mobile-open])) :is(
              dialog,
              [role='dialog'],
              [aria-modal='true'],
              [data-testid*='modal'],
              [data-testid*='popup']
            ) {
              visibility: hidden !important;
              opacity: 0 !important;
              pointer-events: none !important;
            }

            dialog,
            [role='dialog'],
            [aria-modal='true'],
            [data-testid*='modal'],
            [data-testid*='popup'] {
              border-radius: 28px !important;
              overflow: hidden !important;
            }

            button {
              border-radius: 999px !important;
            }

            input,
            select,
            textarea {
              border-radius: 18px !important;
              border-color: rgba(85, 101, 75, 0.18) !important;
            }

            code,
            [class*='discount'],
            [class*='code'],
            [data-testid*='discount'] {
              border-radius: 16px !important;
              background: linear-gradient(135deg, #f8f3ea 0%, #e6eed8 100%) !important;
              color: #43503d !important;
              font-weight: 700 !important;
            }
          `;
          root.appendChild(style);
        }

        function markManaged(element) {
          if (!(element instanceof HTMLElement)) return;
          element.setAttribute('data-yc-mobile-managed', 'true');
          if (document.body.classList.contains('yc-forms-mobile-open')) {
            element.setAttribute('data-yc-mobile-open', 'true');
          } else {
            element.removeAttribute('data-yc-mobile-open');
          }
          if (element.shadowRoot) injectShadowStyles(element.shadowRoot);
        }

        function refreshEmbedReferences() {
          embedHost = document.querySelector(hostSelector);
          if (embedHost) markManaged(embedHost);

          const nestedEmbed = embedHost?.shadowRoot?.querySelector(nestedSelector) || document.querySelector(nestedSelector);
          if (nestedEmbed) markManaged(nestedEmbed);

          return Boolean(embedHost || nestedEmbed);
        }

        function getManagedRoots() {
          const roots = [];
          const nestedEmbed = embedHost?.shadowRoot?.querySelector(nestedSelector) || document.querySelector(nestedSelector);

          if (embedHost) roots.push(embedHost);
          if (embedHost?.shadowRoot) roots.push(embedHost.shadowRoot);
          if (nestedEmbed) roots.push(nestedEmbed);
          if (nestedEmbed?.shadowRoot) roots.push(nestedEmbed.shadowRoot);

          return roots;
        }

        function isVisible(element) {
          if (!(element instanceof HTMLElement)) return false;
          const styles = window.getComputedStyle(element);
          if (styles.display === 'none' || styles.visibility === 'hidden' || Number(styles.opacity) === 0) {
            return false;
          }
          const rect = element.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0;
        }

        function isPopupVisible() {
          return getManagedRoots().some((root) =>
            popupSelectors.some((selector) => Array.from(root.querySelectorAll(selector)).some((node) => isVisible(node)))
          );
        }

        function findTriggerButton() {
          for (const root of getManagedRoots()) {
            for (const selector of triggerSelectors) {
              const candidates = Array.from(root.querySelectorAll(selector));
              for (const candidate of candidates) {
                if (!(candidate instanceof HTMLElement) || !isVisible(candidate)) continue;
                const label = `${candidate.textContent || ''} ${candidate.getAttribute('aria-label') || ''}`
                  .trim()
                  .toLowerCase();
                if (denylist.some((term) => label.includes(term))) continue;
                return candidate;
              }
            }
          }
          return null;
        }

        function removeLegacyTeaserArtifacts() {
          const leafChars = new Set(['🌿', '🍃']);
          const candidateSelectors = [
            '.yc-forms-mobile-teaser__leaf',
            '.yc-forms-mobile-teaser__leaf-icon',
            '.yc-forms-mobile-teaser__sprout',
            '.yc-forms-mobile-leaf',
            '.yc-forms-teaser-leaf',
            '.yc-forms-mobile-teaser > span',
          ];

          for (const selector of candidateSelectors) {
            document.querySelectorAll(selector).forEach(function (node) {
              if (node instanceof HTMLElement) {
                const text = (node.textContent || '').trim();
                if (!text || leafChars.has(text) || selector.endsWith('> span')) {
                  node.remove();
                }
              }
            });
          }

          document.querySelectorAll('.yc-forms-mobile-teaser, body > *').forEach(function (node) {
            if (!(node instanceof HTMLElement)) return;
            const text = (node.textContent || '').trim();
            if (!leafChars.has(text)) return;
            const className = typeof node.className === 'string' ? node.className : '';
            if (
              className.includes('yc-forms') ||
              node.closest('.yc-forms-mobile-teaser') ||
              node.getAttribute('style')?.includes('position: fixed')
            ) {
              node.remove();
            }
          });
        }

        function removeHeaderLeafArtifacts() {
          const leafRegex = /^[\s🌿🍃]+$/;
          const headerRoot = document.querySelector('#header-group');
          if (!headerRoot) return;

          function isProtectedLeafNode(node) {
            if (!(node instanceof HTMLElement)) return false;
            return Boolean(
              node.closest('.header-seeds-pill, [href*="/pages/my-rewards"], .bw-loyalty-wrapper, .bw-loyalty-earn')
            );
          }

          const candidates = headerRoot.querySelectorAll('span, div, i, em, strong, button, a');

          candidates.forEach(function (node) {
            if (!(node instanceof HTMLElement)) return;
            if (node.closest('.yc-forms-mobile-teaser') || isProtectedLeafNode(node)) return;

            const text = (node.textContent || '').trim();
            if (!text || !leafRegex.test(text)) return;

            node.setAttribute('data-yc-header-leaf', 'true');
            node.remove();
          });

          const walker = document.createTreeWalker(headerRoot, NodeFilter.SHOW_TEXT, {
            acceptNode(node) {
              if (
                !node.parentElement ||
                node.parentElement.closest('.yc-forms-mobile-teaser') ||
                isProtectedLeafNode(node.parentElement)
              ) {
                return NodeFilter.FILTER_REJECT;
              }
              const text = (node.textContent || '').trim();
              return text && leafRegex.test(text) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
            },
          });

          const textNodes = [];
          while (walker.nextNode()) {
            textNodes.push(walker.currentNode);
          }

          textNodes.forEach(function (node) {
            const parent = node.parentElement;
            if (!parent || isProtectedLeafNode(parent)) return;

            node.textContent = '';
            parent.setAttribute('data-yc-header-leaf', 'true');
          });
        }

        function removeMenuDrawerLeafArtifacts() {
          const headerRoot = document.querySelector('#header-group') || document;
          const leafPrefixRegex = /^[\s\u200b\u200c\u200d🌿🍃]+/;
          const leafOnlyRegex = /^[\s🌿🍃]+$/;
          const textTargets = headerRoot.querySelectorAll(
            '.menu-drawer__menu-item-text, .menu-list__link-title, .menu-list__link .wrap-text, .mega-menu__link .wrap-text'
          );
          textTargets.forEach(function (node) {
            if (!(node instanceof HTMLElement)) return;
            const text = node.textContent || '';
            const cleaned = text.replace(leafPrefixRegex, '').trimStart();
            if (cleaned !== text) node.textContent = cleaned;
          });

          headerRoot.querySelectorAll('[aria-label], [title]').forEach(function (node) {
            if (!(node instanceof HTMLElement)) return;
            const ariaLabel = node.getAttribute('aria-label');
            const title = node.getAttribute('title');
            if (typeof ariaLabel === 'string') {
              const cleanedAria = ariaLabel.replace(leafPrefixRegex, '').trimStart();
              if (cleanedAria !== ariaLabel) node.setAttribute('aria-label', cleanedAria);
            }
            if (typeof title === 'string') {
              const cleanedTitle = title.replace(leafPrefixRegex, '').trimStart();
              if (cleanedTitle !== title) node.setAttribute('title', cleanedTitle);
            }
          });

          headerRoot.querySelectorAll('header-drawer .menu-drawer, .menu-drawer').forEach(function (drawer) {
            if (!(drawer instanceof HTMLElement)) return;
            drawer.querySelectorAll('li, a, summary, button, span, div').forEach(function (node) {
              if (!(node instanceof HTMLElement)) return;
              const className = typeof node.className === 'string' ? node.className : '';
              const ariaLabel = (node.getAttribute('aria-label') || '').trim();
              const text = (node.textContent || '').trim();
              if (className.includes('icon-caret') || className.includes('header-drawer-icon')) return;
              if (!leafOnlyRegex.test(text) && !leafOnlyRegex.test(ariaLabel)) return;
              node.remove();
            });
          });
        }

        function bindMenuLeafSanitizer() {
          const headerRoot = document.querySelector('#header-group');
          if (!headerRoot) return;

          const sanitizeNow = function () {
            removeHeaderLeafArtifacts();
            removeMenuDrawerLeafArtifacts();
          };

          headerRoot
            .querySelectorAll('header-drawer summary, .header__icon--menu, .header__drawer')
            .forEach(function (trigger) {
              if (!(trigger instanceof HTMLElement) || trigger.dataset.ycLeafSanitizerBound === '1') return;
              trigger.dataset.ycLeafSanitizerBound = '1';
              trigger.addEventListener('pointerdown', sanitizeNow, { capture: true });
              trigger.addEventListener('click', sanitizeNow, { capture: true });
              trigger.addEventListener('touchstart', sanitizeNow, { capture: true, passive: true });
            });
        }

        function createTeaser() {
          if (teaserNode) return teaserNode;

          teaserNode = document.createElement('div');
          teaserNode.className = 'yc-forms-mobile-teaser';
          teaserNode.hidden = true;
          teaserNode.innerHTML = `
            <button class="yc-forms-mobile-teaser__close" type="button" aria-label="${copy.closeLabel}">&times;</button>
            <button class="yc-forms-mobile-teaser__card" type="button" aria-label="${copy.openLabel}">
              <span class="yc-forms-mobile-teaser__eyebrow">${copy.eyebrow}</span>
              <span class="yc-forms-mobile-teaser__title">${copy.title}</span>
              <span class="yc-forms-mobile-teaser__meta">${copy.meta}</span>
            </button>
          `;

          const closeButton = teaserNode.querySelector('.yc-forms-mobile-teaser__close');
          const cardButton = teaserNode.querySelector('.yc-forms-mobile-teaser__card');

          closeButton?.addEventListener('click', function () {
            teaserNode.hidden = true;
            teaserNode.classList.remove('is-visible');
            isDismissed = true;
            sessionStore?.setItem(dismissKey, '1');
          });

          cardButton?.addEventListener('click', async function () {
            document.body.classList.add('yc-forms-mobile-open');
            hideTeaser();
            refreshEmbedReferences();

            const start = Date.now();
            while (Date.now() - start < 2400) {
              if (isPopupVisible()) {
                popupWasVisible = true;
                return;
              }
              const trigger = findTriggerButton();
              if (trigger) {
                trigger.click();
              } else if (embedHost instanceof HTMLElement) {
                embedHost.click();
              }
              await new Promise((resolve) => window.setTimeout(resolve, 180));
              refreshEmbedReferences();
            }

            document.body.classList.remove('yc-forms-mobile-open');
            syncTeaserState();
          });

          document.body.appendChild(teaserNode);
          return teaserNode;
        }

        function hideTeaser() {
          if (!teaserNode) return;
          teaserNode.hidden = true;
          teaserNode.classList.remove('is-visible');
        }

        function showTeaser() {
          if (isDismissed) return;
          if (!refreshEmbedReferences()) return;

          const teaser = createTeaser();
          if (!teaser.hidden) return;

          teaser.hidden = false;
          window.requestAnimationFrame(() => teaser.classList.add('is-visible'));
        }

        function syncTeaserState() {
          if (!refreshEmbedReferences()) return;

          const popupVisible = isPopupVisible();

          if (popupVisible) {
            popupWasVisible = true;
            document.body.classList.add('yc-forms-mobile-open');
            hideTeaser();
            return;
          }

          if (popupWasVisible) {
            document.body.classList.remove('yc-forms-mobile-open');
            popupWasVisible = false;
          }

          if (!document.body.classList.contains('yc-forms-mobile-open')) {
            showTeaser();
          }
        }

        let frame = 0;
        let headerObserver = null;
        let formsObserver = null;
        let bootstrapObserver = null;
        let observedFormsRoot = null;

        function scheduleTeaserSync() {
          if (frame) return;
          frame = window.requestAnimationFrame(function () {
            frame = 0;
            removeLegacyTeaserArtifacts();
            removeHeaderLeafArtifacts();
            removeMenuDrawerLeafArtifacts();
            bindMenuLeafSanitizer();
            syncTeaserState();
            bindFormsObserver();
            window.dispatchEvent(new Event('yc:mobile-floating-update'));
          });
        }

        function bindHeaderObserver() {
          const headerRoot = document.querySelector('#header-group');
          if (!(headerRoot instanceof HTMLElement) || headerObserver) return;
          headerObserver = new MutationObserver(scheduleTeaserSync);
          headerObserver.observe(headerRoot, { childList: true, subtree: true });
        }

        function bindFormsObserver() {
          refreshEmbedReferences();
          const nestedEmbed = embedHost?.shadowRoot?.querySelector(nestedSelector) || document.querySelector(nestedSelector);
          const formsRoot = nestedEmbed?.shadowRoot || nestedEmbed || embedHost?.shadowRoot || embedHost;
          if (!formsRoot || formsRoot === observedFormsRoot) return;

          formsObserver?.disconnect();
          formsObserver = new MutationObserver(scheduleTeaserSync);
          formsObserver.observe(formsRoot, { childList: true, subtree: true });
          observedFormsRoot = formsRoot;

          if (bootstrapObserver) {
            bootstrapObserver.disconnect();
            bootstrapObserver = null;
          }
        }

        function bindBootstrapObserver() {
          if (bootstrapObserver || observedFormsRoot) return;
          bootstrapObserver = new MutationObserver(function () {
            if (!refreshEmbedReferences()) return;
            bindFormsObserver();
            scheduleTeaserSync();
          });
          bootstrapObserver.observe(document.body, { childList: true, subtree: true });

          window.setTimeout(function () {
            bootstrapObserver?.disconnect();
            bootstrapObserver = null;
          }, 12000);
        }

        bindHeaderObserver();
        bindFormsObserver();
        bindBootstrapObserver();
        window.addEventListener('pageshow', scheduleTeaserSync);
        window.addEventListener('resize', scheduleTeaserSync);
        document.addEventListener('visibilitychange', function () {
          if (!document.hidden) scheduleTeaserSync();
        });
        scheduleTeaserSync();
      })();
